<div (window:resize)="onResize($event)" class="mi-grid-component passengerDayBokingGrid"
  [ngClass]="[overflowShow ? 'overflow-show' :  '', (!bottomSearchBar && topBorder) ? 'top-border' : '']">
  <div id="p-table-list">
    <div class="search-and-export-data-panel" style="display: flex;">
      <div class="mi-grid-layout-container col-12 ml-0-8">
        <div class="search-section">
          <label *ngIf="!bottomSearchBar" for="search-bar" title="Search" class="fa fa-search input-icon"></label>
          <input *ngIf="!bottomSearchBar" type="text" class="grid-search-bar top" [(ngModel)]="search"
            (keyup)="onQuickFilterChanged($event, dt)" [placeholder]="searchPlaceHolderValue" />
          <label *ngIf="!bottomSearchBar && search !== ''" (click)="onResetSearchInput()" for="search-bar"
            [title]="clearSearch" class="fa fa-close input-close-icon"></label>
        </div>
        
        <div class="top-pagination-section" *ngIf="pagination && !openSidebar">
          <span class="grid-total-count total-count-top">Total Records: {{totalRecords}}</span>
          <div class="pagination-controls">
            <p-paginator 
              [rows]="paginationPageSize" 
              [totalRecords]="totalRecords" 
              [first]="offset"
              (onPageChange)="onPageChange($event)"
              [showFirstLastIcon]="true"
              [showPageLinks]="true"
              [showJumpToPageDropdown]="false"
              [showCurrentPageReport]="false">
              <!-- [rowsPerPageOptions]="[10, 25, 50, 100]" -->
            </p-paginator>
          </div>
          <div class="action-legend" *ngIf="showActionLegend">
            <div class="legend-item">
              <span class="legend-icon assign-icon"></span>
              <span class="legend-text">Assign</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon reassign-icon"></span>
              <span class="legend-text">Reassign</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon review-icon"></span>
              <span class="legend-text">Review</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon merge-icon"></span>
              <span class="legend-text">Merge</span>
            </div>
            <div class="legend-item">
              <span class="legend-icon demerge-icon"></span>
              <span class="legend-text">Unmerge</span>
            </div>
          </div>
        </div>
        
        <div class="export-section">
          <span class="export-button top" *ngIf="!bottomExportButton && (exportUrl !== '') && totalRecords > 0">
            <span class="header-action-btn export" (click)="exportGridExcel($event)" title="Download Excel">
              XLS
              <i class="fa fa-fw fa-file-excel-o" aria-hidden="true"></i>
            </span>
          </span>

          <span *ngIf="showSecondaryExport && !bottomExportButton && (exportUrlSecond !== '') && totalRecords > 0" class="export-button top">
            <span class="header-action-btn export" (click)="exportGridExcelSecondary($event)" title="Download Day Wise Excel">
              XLS Day Wise
              <i class="fa fa-fw fa-file-excel-o" aria-hidden="true"></i>
            </span>
          </span>

          <span class="export-button top" *ngIf="!bottomExportButton && (printUrl !== '') && totalRecords > 0">
            <span class="header-action-btn export" (click)="exportGridPdf($event)" title="Download Pdf">
              PDF
              <i class="fa fa-fw fa-file-pdf-o" aria-hidden="true"></i>
            </span>
          </span>

          <span class="export-button top" *ngIf="(printQr) && totalRecords > 0">
            <span class="printQR-btn" (click)="printQRCodes($event)" title="Download Pdf" icon="fa fa-file">
              <i class="fa fa-fw fa-file-pdf-o" aria-hidden="true"></i>
              QR Codes
            </span>
          </span>
        </div>
      </div>
    </div>
    <div class="scroll-bar-css" (scroll)="onChangeScroll($event)"
      [ngStyle]="{'max-height': gridScrollHeight,'overflow-y': 'auto', 'overflow-x': 'hidden'}">
      <div class="col-12 grid-content-data">
        <p-table #dt [ngClass]="isDetailScreen ? 'detail-screen-available' : ''" [lazy]="true"
          [rows]="paginationPageSize" metaKeySelection="false" [value]="datasource" [paginator]="false"
          [totalRecords]="totalRecords" (onLazyLoad)="loadDatasourceLazy($event)" [selectionMode]="rowSelection"
          (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [(selection)]="selectedRecords"
          [resizableColumns]="enableResizer" [first]="offset"
          [scrollable]="gridScrollable" 
          [scrollHeight]="gridTableScrollHeight" >

          <ng-template pTemplate="header">
            <tr >
              <ng-container *ngFor="let col of columnDefs">
                <th *ngIf="col.allShuttleSidebar" style="text-align: center; width: 50px;">
                  <p-tableHeaderCheckbox [value]="selectedCheckbox" (click)="onSelectAllCheckboxClick($event)"></p-tableHeaderCheckbox>
                </th>
                <th *ngIf="col.mergePopupCheckbox" style="width:50px">
                  <input type="checkbox" [ngModel]="selectedMergeCheckbox" (click)="onMergeSelectAllCheckboxClick($event)" />
                </th>
                <th *ngIf="col.resize && enableResizer && !col.allShuttleSidebar && !col.mergePopupCheckbox" pResizableColumn
                  [pSortableColumn]="(col?.sort) ? col?.sortField ? col?.sortField : col.field: ''" [width]="col?.width"
                  title="{{col?.header}}"
                  [ngStyle]="{'padding-left': col?.sort?'':'14px'}">
                  <!-- , 'width': (col?.header == 'Booking ID' && totalRecords > 0) ? '7%' : '' -->
                  <p-sortIcon *ngIf="col?.sort" [field]="col.field"></p-sortIcon>
                  {{col.header}}
                </th>
                <th *ngIf="!col.resize && !col.allShuttleSidebar && !col.mergePopupCheckbox" [pSortableColumn]="(col?.sort) ? col.field: ''" title="{{col.header}}"
                  [width]="col?.width">
                  <p-sortIcon *ngIf="col?.sort" [field]="col.field"></p-sortIcon>
                  {{col.header}}
                </th>
              </ng-container>

              <th style="text-align: center;" *ngIf="actionButtonsDefs.length">
                Action
              </th>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td *ngIf="actionButtonsDefs.length === 0" style="text-align: center;" [attr.colspan]="columnDefs.length">
                No records found
              </td>
              <td *ngIf="actionButtonsDefs.length > 0" style="text-align: center;"
                [attr.colspan]="columnDefs.length + 1">
                No records found
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columnDefs" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" [class]="rowIndex%2==0?'even-row':'odd-row'"
              [ngStyle]="{
                'background-color': rowData['rowBgColorCode'] ? rowData['rowBgColorCode'] : '',
                '--flash-color': rowData['showAlertForSpecialRequestColor'] ? toRgba20(rowData['showAlertForSpecialRequestColor']) : (rowData['rowBgColorCode'] ? toRgba20(rowData['rowBgColorCode']) : ''),
                '--flash-color-rgb': rowData['showAlertForSpecialRequestColor'] ? toRgbTriplet(rowData['showAlertForSpecialRequestColor']) : (rowData['rowBgColorCode'] ? toRgbTriplet(rowData['rowBgColorCode']) : '')
              }"
              [ngClass]="isEmergency(rowData) ? 'flash-emergency-row' : ''">
              <td [ngClass]="[col?.class && !col?.isDropDown ? col.class : '', col?.isDropDown ? 'visible-dropdown' : '']"
                *ngFor="let col of columnDefs" [ngStyle]="{'max-width': col?.width? col?.width+'px':''} ">
                <div class="grid-dropdown-section filter-drop-down width-100per"
                  [ngClass]="[col?.condColorClass ? getDropdownColor(rowData): '', col?.class ? col.class : '']"
                  *ngIf="col?.isDropDown">
                  <!-- style="padding-right: 30%;" -->
                  <p-dropdown
                    [options]="(rowData[col.subServiceType] === subServiceThirdParty)?col.thirdPartyOptions:col.options"
                    [disabled]="col.disabled? true: false" [placeholder]="'label_select' | translate"
                    [(ngModel)]="rowData[col.field]" [style]="{'width':'100%','border-radius': '4px','border': 'solid 1px #dadada',
                  'background-color': '#eee'}" data-action-type="DROP-DOWN" (click)="onDropDownClick($event, rowData)"
                    (onChange)="onDropDownChange($event, rowData, col?.type)" appendTo="body"
                    [title]="getDropdownLabel(col.options, rowData[col.field])">
                  </p-dropdown>
                  <br />
                  <div *ngIf="col?.isEditField && (rowData[col.subServiceType] !== subServiceThirdParty)"
                    class="sm:col-12 md:col-12 lg:col-12">
                    <div class="grid flex justify-content-start align-items-center">
                      <!-- <div class="col-7 edit-field p-0 mr-2" [ngClass]="col?.borderClass ? col?.borderClass: ''"
                      [ngStyle]="{'height':'25px','border-color': rowData[col.serviceAreaId] ? '' : '#D90707', 'border-radius': '2px',
                      'border': 'solid 1px #dadada',
                      'background-color': '#fff'}">
                      <div (click)="onEditClick($event, rowData)"
                        class="col-12 md:col-12 lg:col-12 width-80-per pad-top-2px"
                        [title]="rowData[col.locationId]?rowData[col.locationId]:''">
                        {{rowData[col.serviceAreaId]? (rowData[col.locationId]?rowData[col.locationId]:''):
                        (rowData[col.locationId]?rowData[col.locationId]: no_zone)}}
                      </div>
                      <div *ngIf="col?.isEditIcon  &&  checkIsEditable(rowData[col?.bookingStatus])" class="edit-icon">
                        <span (click)="onEditClick($event, rowData)">
                          <img src="/assets/images/temp/pencilIcon.svg" alt=""
                            style="margin-top: 0.15rem; height: 14px;">
                        </span>
                      </div>
                    </div> -->
                      <div class="col-12 grid p-0 m-0 flex justify-content-start align-items-start">
                        <div class="col-5 p-0 noCSS mr-2"
                          *ngIf="rowData[col.pickUpEtaStr] && rowData[col.bookingStatus] == 80">
                          <div class="pickupETA noCSS p-1 greenBox" (click)="onEtaClick($event, rowData)"
                            [id]="rowData.id">
                            Pickup ETA: {{rowData[col.pickUpEtaStr]}}
                          </div>
                        </div>

                        <div class="col-5 noCSS p-0" *ngIf="rowData[col.estimatedDropOffTimeStr]">
                          <div class="dropETA noCSS" [id]="rowData.id"
                            [ngClass]="(rowData[col.bookingStatus] === 130 || rowData[col.bookingStatus] === 90) ? 'cursorPointer' : ''"
                            (click)="(rowData[col.bookingStatus] === 130 || rowData[col.bookingStatus] === 90) ? onEtaClick($event, rowData) : null">
                            Drop
                            Off
                            ETA :
                            {{rowData[col.estimatedDropOffTimeStr]}}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 grid m-0 mt-1 flex justify-content-start align-items-start" *ngIf="rowData[col.flightDetailsNote]"   [ngClass]="{
                        'red-text': rowData[col.delayedArrival],
                        'green-text': !rowData[col.delayedArrival] && rowData[col.earlyArrival],
                        'blue-text': !rowData[col.delayedArrival] && !rowData[col.earlyArrival]
                      }" style="width: 100%;">
                        <span [title]="rowData[col.flightDetailsNote]" style="display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          {{rowData[col.flightDetailsNote]}}
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>

                <div *ngIf="col?.isSwitchBtn">
                  <p-inputSwitch (onChange)="onSwitchChange($event, rowData)"
                    [disabled]="(!rowData[col.disableField] && !rowData[col.field]) || col.isDisable"
                    [(ngModel)]="rowData[col.field]">
                  </p-inputSwitch>
                </div>

                <div *ngIf="col.cellRendererHtml == undefined && !col?.isDropDown && !col?.isSwitchBtn">
                  <span [title]="rowData[col.field]" *ngIf="col?.bold" class="apply-500-font">{{(rowData[col.field] ===
                    null || rowData[col.field] === '') ? 'NA' : rowData[col.field]}}</span>
                  <span [title]="rowData[col.field]?rowData[col.field]:'NA'" *ngIf="!col?.bold">{{(rowData[col.field]
                    ===
                    null || rowData[col.field] === '') ? 'NA' : rowData[col.field]}}</span>
                </div>

                <div *ngIf="col.cellRendererHtml != undefined && !col?.isDropDown && !col?.isSwitchBtn"
                  [innerHtml]="rowData[col.field]">
                </div>
                <div *ngIf="col?.allShuttleSidebar">
                  <input type="checkbox" [ngModel]="selectedCheckbox" (click)="onCheckboxClick($event,rowData)" />
                  <!-- <td *ngIf="col.headerCheckbox" style="text-align: center; width: 50px;"> -->
                  <!-- Row Checkbox -->
                  <!-- <p-tableCheckbox [value]="rowData"></p-tableCheckbox> -->
                  <!-- </td> -->
                </div>
                <div *ngIf="col?.mergePopupCheckbox" class="merge-popup-checkbox-column">
                  <input type="checkbox" [ngModel]="isMergeRowSelected(rowData)" (click)="onMergeCheckboxClick($event, rowData)" />
                </div>
                <div *ngIf="col?.assignDriverPopup" class="position-relative">
                  <input [id]="rowIndex" type="text" class="grid-search-bar top"
                    [value]="rowData.driverFirstName? rowData.driverFirstName +' '+ rowData.driverLastName: ''"
                    placeholder="Select Driver" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="ASSIGN-DRIVER-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.assignShuttlePopup" class="position-relative">
                  <input type="text" class="grid-search-bar top" [value]="rowData.busName? rowData.busName: ''"
                    placeholder="Select Shuttle" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="ASSIGN-SHUTTLE-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.showDriverPopup" class="position-relative">
                  <input [id]="rowIndex" type="text" class="grid-search-bar top"
                    [value]="rowData.driverFirstName ? rowData.driverFirstName +' '+ rowData.driverLastName : (rowData?.id == selectedDriverData?.tourId ? selectedDriverData?.fullName : (selectedDriverData?.tourIdList?.includes(rowData?.id) ? selectedDriverData?.fullName : ''))"
                    placeholder="Select Driver" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="SELECT-DRIVER-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.showShuttlePopup" class="position-relative">
                  <input [id]="rowIndex" type="text" class="grid-search-bar top"
                    [value]="rowData.busName ? rowData.busName : (rowData?.id == selectedBusData?.tourId ? selectedBusData?.busName : (selectedBusData?.tourIdList?.includes(rowData?.id) ? selectedBusData?.busName : ''))"
                    placeholder="Select Shuttle" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="SELECT-SHUTTLE-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.fromToArrow">
                  <li class="sprite fa-right-side-arrow"></li>
                </div>
              </td>

              <td [ngClass]="col?.class ? col.class : ''" *ngIf="actionButtonsDefs.length">
                <span *ngFor="let btn of actionButtonsDefs">
                  <button *ngIf="rowData[btn.field] !== 'deactivated'" (click)="actionBtnClick(rowData, btn.class)"
                    [icon]="btn.icon" [title]="btn?.label" pButton appRipple appRipple [label]="btn?.heading" pButton
                    appRipple appRipple [class]="btn.class"></button>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!-- Scroll to Top Button -->
  <div class="scroll-to-top-button" 
       [class.visible]="showScrollToTopButton" 
       (click)="scrollToTop()"
       title="Go to Top">
    <i class="fa fa-chevron-up"></i>
  </div>
</div>